//import liraries
import React, { useEffect, useState } from "react";
import { Dimensions } from "react-native";

import { CreateResponsiveStyle, DEVICE_SIZES,  } from 'rn-responsive-styles';


const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;




const useStyles = CreateResponsiveStyle({
  mainContainer: {
    width: "100%",
    height: 400,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginLeft: 20,
    marginTop: 20,
    
  },
  iconContainer: {
    marginTop: "2%",
    flexDirection: isSmallDevice || isTabView ? "column" : "row",
    paddingLeft: 30,
    paddingHorizontal: isSmallDevice || isTabView ? null : 50,
    marginLeft: isSmallDevice || isTabView ? null : 10,
  },
  backIcon: {
    height: 19,
    width: 19,
    resizeMode: "center",
    opacity: 0.8,
  },

  textStyle: {
    color: '#999999',
    fontSize: 13,
    marginLeft: 20,
  },
  rowContainer: {
    flexDirection: 'row',
  },
  subContainer: {
    flexDirection: 'column',
    width: 281,
    height: 185.5,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ff6e6e",
    marginLeft: 70,
    marginTop: 20,
    justifyContent: 'space-between'
  },
  acTypeView: {
    flexDirection: 'column',
    width: 280,
    height: 96.2,
  },
  autoPayHeading: {
    width: 150,
    height: 16,
    fontSize: 14,
    fontWeight: "600",
    color: "#bd2d37",
    marginLeft: 20,
    paddingTop: 10
  },
  autoPayText: {
    width: 247,
    fontSize: 11,
    fontWeight: "500",
    color: "#02122c",
    marginLeft: 20,
    paddingTop: 15,
  },
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 15,
  },
  columnView: {
    flexDirection: 'column',
    marginLeft: 50
  },
  choosePoolAccountTypeView: {
    width: 323,
    height: 70,
    justifyContent: 'space-between'
  },
  choosePoolAccountTypeHeading: {
    fontSize: 17,
    fontWeight: "bold",
    color: "#5f5f5f",
  },
  choosePoolAccountTypeText: {
    fontSize: 16,
    fontWeight: "300",
    color: "#757575",
  },
  radioBtnView: {
    paddingTop: 40,
    height: 90,
    justifyContent: 'space-between',
  },
  selectionContainerStyle: {
    flexDirection: 'row',
  },
  radiobuttonOutSideStyle: {
    width: 15,
    height: 15,
    borderRadius: 10,
    borderColor: "#9d1d27",
    borderWidth: 2,
    alignItems: "center",
    justifyContent: "center"
  },
  radioButtonInsideStyle: {
    height: 7,
    width: 7,
    borderRadius: 7,
    backgroundColor: "#9d1d27"
  },
  chooseOptionStyle: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "normal",
    fontStyle: "normal",
    lineHeight: 17,
    letterSpacing: 0,
    textAlign: "left",
    color: "#797673"
  },
  customButton: {
    width: 218,
    height: 37,
    marginLeft: 700
  }


},
  {
    [DEVICE_SIZES.SM]:
    {
      mainContainer:
      {
        width: 528.1,
        height: 730.3,
      },
      rowContainer: {
        flexDirection: 'column',
      },
      columnView: {
        flexDirection: 'column',
        marginLeft: 50
      },
      columnView: {
        marginTop: 20,
        marginLeft: 70,
      },
      customButton: {
        width: 218,
        height: 37,
        marginLeft: 300,
        marginTop: 30
      },
      choosePoolAccountTypeText:{
        width:'90%'
      }
    },

    [DEVICE_SIZES.MD]:
    {
      mainContainer:
      {
        flexDirection: 'column',
        width: 528.1,
        height: 730.3,
      },
      rowContainer: {
        flexDirection: 'column',
      },
      columnView: {
        marginTop: 20,
        marginLeft: 70,
      },
      customButton: {
        width: 218,
        height: 37,
        marginLeft: 300,
        marginTop: 30
      }
    },
    [DEVICE_SIZES.XS]:
    {
      mainContainer:
      {
        flexDirection: 'column',
        width: 321.8,
        height: 754,
        marginLeft: 0
      },
      rowContainer: {
        flexDirection: 'column',
      },
      subContainer: {
        flexDirection: 'column',
        width: 281,
        height: 185.5,
        borderRadius: 10,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#ff6e6e",
        marginLeft: 20,
        marginTop: 20,
        justifyContent: 'space-between'
      },
      columnView: {
        marginTop: 30,
        marginLeft: 25,
      },
      customButton: {
        width: 154.2,
        height: 31.3,
        marginLeft: 130,
        marginTop: 100
      },
      choosePoolAccountTypeText:{
        width:'90%'
      }

    },
  }
);


export default useStyles;
